import { Context } from '@nuxt/types'
import axios, { AxiosInstance } from 'axios'
import { Logger } from '../composition/Logger'

export type TSplunkClientPayload = {
  message: 'Completed' | 'Started' | 'Failed'
  action: string
  error?: {
    message: string
  }
  businessOperationName?: string
  businessOperationCode?: number
  info?: Record<string, unknown>
}

export class SplunkClient {
  private readonly client: AxiosInstance
  private readonly url: string

  constructor(ctx: Context) {
    const { $config } = ctx
    this.url = $config.BACKEND_SPLUNK_URL
    this.client = axios.create({
      method: 'POST',
      baseURL: $config.BACKEND_BASE_URL,
    })
  }

  static fromEnv(): SplunkClient {
    const instance = Object.create(SplunkClient.prototype) as SplunkClient
    ;(instance as any).url = process.env.BACKEND_SPLUNK_URL as string
    ;(instance as any).client = axios.create({
      method: 'POST',
      baseURL: process.env.BACKEND_PUBLIC_URL as string,
    })
    return instance
  }

  public async send(payload: TSplunkClientPayload) {
    try {
      await this.client(this.url, {
        data: {
          message: payload.message,
          action: payload.action,
          businessOperationName:
            payload.businessOperationName || 'Unnamed operation',
          businessOperationCode: payload.businessOperationCode || 0,
          ...(payload.error && {
            error: { message: payload.error.message },
          }),
          info: [
            {
              timestamp: new Date().toISOString(),
              ...payload.info,
            },
          ],
        },
      })
    } catch (e) {
      Logger.error(
        'SplunkClient: Error when send splunk log onto backend',
        payload,
        e
      )
    }
  }
}
